import { render } from "./CanvasDocuments.vue?vue&type=template&id=320eb264&scoped=true"
import script from "./CanvasDocuments.vue?vue&type=script&lang=js"
export * from "./CanvasDocuments.vue?vue&type=script&lang=js"

import "./CanvasDocuments.vue?vue&type=style&index=0&id=320eb264&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320eb264"]])

export default __exports__